<template>
  <v-card class="my-8">
    <v-card-title class="d-flex align-center">
      <span class="mr-4">{{ title }}</span>
      <v-select
        v-model="scoreType"
        :items="scoreTypeOptions"
        label="Score Type"
        dense
        outlined
        hide-details
        style="max-width: 200px"
        @change="getData"
      />
    </v-card-title>
    <v-card-text>
      <line-chart
        :series="series"
        :labels="labels"
        :x-axis="xaxis"
        :y-axis="yaxis"
        :colors="series.map((s) => s.color)"
        :animations="false"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { chartColors } from "@/utils/constants";
import useAxios from "@/hooks/useAxios";
// import debounce from "lodash/debounce";
import LineChart from "@/components/common/charts/LineChart.vue";

export default {
  name: "ScoreProgressionChart",
  components: { LineChart },
  props: {
    title: {
      type: String,
      default: "Progression des scores",
    },
    initialScoreType: {
      type: String,
      default: "all",
    },
  },
  setup() {
    const { axiosGet } = useAxios();

    return {
      axiosGet,
    };
  },
  created() {
    // this.debouncedGetData();
    setTimeout(() => {
      this.getData();
    }, 500);
  },
  data() {
    return {
      scoreType: this.initialScoreType,
      scoreTypeOptions: [
        { text: "All", value: "all" },
        { text: "RUM", value: "rum_score" },
        { text: "CrUX", value: "crux_score" },
      ],
      colors: chartColors,
      xaxis: {
        type: "datetime",
        labels: {
          formatter: function (val) {
            return new Date(val).toLocaleDateString();
          },
        },
      },
      yaxis: [
        {
          min: 0,
          max: 100,
          forceNiceScale: false,
        },
      ],
      series: [],
      labels: [],
      total: 0,
    };
  },
  methods: {
    // debouncedGetData: debounce(async function () {
    //   await this.getData();
    // }, 500),
    // Generate a consistent color index for each site name
    getColorIndex(siteName) {
      let hash = 0;
      for (let i = 0; i < siteName.length; i++) {
        hash = (hash << 5) - hash + siteName.charCodeAt(i);
        hash = hash & hash; // Convert to 32bit integer
      }
      return Math.abs(hash) % this.colors.length;
    },

    processDataIntoSeries: function (items) {
      const seriesMap = new Map();
      const siteColorMap = new Map();

      if (this.scoreType === "all") {
        const siteNames = [
          ...new Set(items.map((item) => item.site_name)),
        ].sort();
        siteNames.forEach((siteName) => {
          siteColorMap.set(siteName, this.colors[this.getColorIndex(siteName)]);
        });
      }

      for (const item of items) {
        const { site_name, date, rum_score, crux_score } = item;
        const timestamp = new Date(date).getTime();

        if (this.scoreType === "all" || this.scoreType === "rum_score") {
          const seriesName = `${site_name}`;
          if (!seriesMap.has(seriesName)) {
            const color =
              this.scoreType === "all"
                ? siteColorMap.get(site_name)
                : this.colors[this.getColorIndex(site_name)];

            seriesMap.set(seriesName, {
              name: seriesName,
              data: [],
              color: color,
            });
          }
          seriesMap.get(seriesName).data.push({
            x: timestamp,
            y: rum_score,
          });
        }

        if (this.scoreType === "all" || this.scoreType === "crux_score") {
          const seriesName = `${site_name} (CrUX)`;
          if (!seriesMap.has(seriesName)) {
            const color =
              this.scoreType === "all"
                ? siteColorMap.get(site_name)
                : this.colors[this.getColorIndex(site_name)];

            seriesMap.set(seriesName, {
              name: seriesName,
              data: [],
              color: color,
            });
          }
          seriesMap.get(seriesName).data.push({
            x: timestamp,
            y: crux_score,
          });
        }
      }
      return Array.from(seriesMap.values()).sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    async getData() {
      const params = {};
      if (this.sites && this.sites.length > 0) {
        params.sites = this.sites.join(",");
      }
      const { data } = await this.axiosGet(
        "/web-perf/cwv-scores-last-30-days",
        params
      );
      this.series = this.processDataIntoSeries(data.items);
    },
  },
  computed: {
    applyFilters() {
      return this.$store.getters["common/getApplyFilters"];
    },
    sites() {
      return this.$store.getters["webPerf/getSites"];
    },
  },
  watch: {
    applyFilters() {
      // this.debouncedGetData();
      this.getData();
    },
  },
};
</script>

<style scoped></style>
